import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CardOverlayModule} from "@pages/user/partials/card-overlay/card-overlay.module";
import {MatCardModule} from "@angular/material/card";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatListModule} from '@angular/material/list';
import {
  RewardCategoryFilterComponent
} from "@app/feature/reward/reward-category-filter/reward-category-filter.component";


@NgModule({
  declarations: [RewardCategoryFilterComponent],
  exports: [RewardCategoryFilterComponent],
  imports: [
    CommonModule,
    MatCardModule,
    CardOverlayModule,
    MatCheckboxModule,
    MatListModule
  ]
})
export class RewardCategoryFilterModule { }
